import type { ICellRendererParams } from 'ag-grid-community'
import type { ReactElement } from 'react'

import { TemplateTypeBadge } from '~/components/Badges'

const TemplateTypeCellRenderer = ({ value }: ICellRendererParams): ReactElement => {
  return value ? <TemplateTypeBadge value={value} /> : <div />
}

export default TemplateTypeCellRenderer
